import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from 'store/AppContext';
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Button from "@material-ui/core/Button";
import Tooltip from '@material-ui/core/Tooltip';
import Typography from "@material-ui/core/Typography";
import PersonIcon from '@material-ui/icons/Person';
import BuildIcon from '@material-ui/icons/Build';
import { getIsAdmin } from 'common/services/authService';


const useStyles = makeStyles(theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbarTitle: {
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    }
  },
  title: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  username: {
    textTransform: "none",
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));

export default function Header() {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { isLoggedIn, user } = context;
  const isAdmin = getIsAdmin(context);

  const handleDrawerToggle = () => {
    context.drawer.set(prevState => {
      return { ...prevState, mobileOpen: !context.drawer.get.mobileOpen };
    });
  };

  if (!isLoggedIn.get) {
    return null;
  }

  return (
    <Fragment>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            className={classes.menuButton}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} color="inherit">Kosningar utan kjörfundar</Typography>
          <Typography
            variant="h6"
            color="inherit"
            align="center"
            className={classes.toolbarTitle}
            noWrap
          >
            {context.activeKosning.get.lysing || "Engin kosning valin"}
          </Typography>
          {isAdmin && (
            <Fragment>
              <Tooltip title="Admin">
                <Button color="inherit" component={Link} to="/admin">
                  <BuildIcon style={{ marginRight: "5px" }} />
                </Button>
              </Tooltip>
            </Fragment>
          )}
          {isLoggedIn.get && (
            <Fragment>
              <Tooltip title="Prófíll">
                <Button color="inherit" component={Link} to="/profill">
                  <PersonIcon style={{ marginRight: "5px" }} />
                  <Typography className={classes.username}>
                    {user.get.details.saml_username}
                  </Typography>
                </Button>
              </Tooltip>
            </Fragment>
          )}
        </Toolbar>
      </AppBar>
    </Fragment>
  );
}
